function validateFilterExpression(filter: unknown) {
  // must be object
  if (typeof filter !== 'object' || Array.isArray(filter) || !filter) return false;

  let nestsMultipleExpressions = false;
  if (
    'operator' in filter &&
    typeof filter.operator === 'string' &&
    'operands' in filter &&
    filter.operands != null
  ) {
    nestsMultipleExpressions = true;
    // only supported operations
    if (!['and', 'or'].includes(filter.operator)) return false;

    // must have list of operands of any length
    if (!Array.isArray(filter.operands)) return false;

    // every operand must be valid
    for (const o of filter.operands) if (!validateFilterExpression(o)) return false;
  }

  let comparesFieldToValue = false;
  if (
    'field' in filter &&
    filter.field != null &&
    'comparator' in filter &&
    filter.comparator != null &&
    'value' in filter &&
    filter.value !== undefined
  ) {
    comparesFieldToValue = true;
    // non-empty field name
    if (typeof filter.field !== 'string' || filter.field === '') return false;
    // non-empty comparator
    if (typeof filter.comparator !== 'string' || filter.comparator === '') return false;
  }

  if (
    (nestsMultipleExpressions && comparesFieldToValue) ||
    (!nestsMultipleExpressions && !comparesFieldToValue)
  )
    return false;

  return true;
}

// validateSearchOptions returns true if formatted correctly based on the rules defined in:
// https://www.notion.so/riskledger/Standard-Search-Interface-bc0b46f109524af3bc96405441543340
// This should help any code verify that it’s constructing the search options correctly for sending to the backend.
export const validateSearchOptions = (options: any) => {
  if (!options) return false;

  // pagination is optional
  if (options.page != null) {
    // must be object of pagination options
    if (typeof options.page !== 'object' || Array.isArray(options.page)) return false;

    // limit is optional int >= 0
    if (
      options.page.limit != null &&
      !(Number.isInteger(options.page.limit) && options.page.limit >= 0)
    )
      return false;

    const offsetChosen = options.page.offset != null;
    const cursorChosen = options.page.cursor != null;
    if ((offsetChosen ? 1 : 0) + (cursorChosen ? 1 : 0) !== 1) return false; // either offset or cursor pagination must be chosen
    if (offsetChosen && !(Number.isInteger(options.page.offset) && options.page.offset >= 0))
      return false;
    if (cursorChosen && typeof options.page.cursor !== 'string') return false; // cursor can be empty
  }

  // sorting is optional
  if (options.sort != null) {
    // must be array of sorting options
    if (!Array.isArray(options.sort)) return false;

    for (const sort of options.sort) {
      // field must be non-empty string
      if (typeof sort.field !== 'string' || sort.field === '') return false;
      // direction must be ascending or descending
      if (!['asc', 'desc'].includes(sort.direction)) return false;
    }
  }

  // filter is optional
  if (options.filter != null && !validateFilterExpression(options.filter)) return false;

  return true;
};
